"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.platformNotConnected.title': 'Account not connected',
    'socialMediaPlan.platformNotConnected.message': 'The following platforms are selected but have no account bound in Settings:',
    'socialMediaPlan.platformNotConnected.hint': 'Go to Settings → Social Media to connect your accounts before publishing.',
    'socialMediaPlan.platformNotConnected.chipTitle': 'Account not connected — go to Settings to bind this platform',
    'socialMediaPlan.platformNotConnected.chipHint': 'Some platforms are not connected.',
    'socialMediaPlan.platformNotConnected.goToSettings': 'Go to Settings',
};
